export default __webpack_public_path__ + "static/media/mishabnwcrop.b6add21c.png";